import { BaseTypography, type BaseTypographyProps } from './BaseTypography'

/**
 * Some consumers need to have dynamic titles, for this case this is fine to use
 */
export const Typography = BaseTypography

export type { BaseTypographyProps as TypographyProps }
